import apiClient from "./apiClient";
import { ApiCollectionResponse } from "../models/ResponseModels/ApiCollectionResponse";
import { ApiSingleResponse } from "../models/ResponseModels/ApiSingleResponse";
import { CleaningTaskResponse } from "../models/ResponseModels/CleaningTaskResponse";
import { UpdateCleaningTaskRequest } from "../models/RequestModels/UpdateCleaningTaskRequest";

export const getCleaningTasksRequest = async (): Promise<
  ApiCollectionResponse<CleaningTaskResponse>
> => {
  const response =
    await apiClient.get<ApiCollectionResponse<CleaningTaskResponse>>(
      "/cleaning-tasks",
    );

  return response.data;
};

export const updateCleaningTaskRequest = async (
  id: number,
  body: UpdateCleaningTaskRequest,
): Promise<ApiSingleResponse<CleaningTaskResponse>> => {
  const response = await apiClient.patch<
    ApiSingleResponse<CleaningTaskResponse>
  >(`/cleaning-tasks/${id}`, body);

  return response.data;
};
